import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.sass'],
    standalone: false
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  @Input() label: string | null = null;
  @Input() placeholder: string | null = 'searchPlaceholder';

  @Input() debounceTime: number = 1000; // debounce time in milliseconds

  @Output() searchTermProvided: EventEmitter<string> = new EventEmitter();

  searchTermControl = new FormControl();
  currentSearchTerm: string = this.searchTermControl.value;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription = this.searchTermControl.valueChanges
      .pipe(debounceTime(this.debounceTime), distinctUntilChanged())
      .subscribe(this.announceSearchTerm)
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private announceSearchTerm = (searchTerm: string): void => {
    this.currentSearchTerm = searchTerm;
    this.searchTermProvided.emit(this.currentSearchTerm);
  }

  clear(): void {
    this.searchTermControl.reset();
  }
}
